// extracted by mini-css-extract-plugin
module.exports = {"textAlert":"TextAlert_textAlert__50BOw"};